import React from "react";
import { Star, Quote } from "lucide-react";
import Reveal from "./Reveal";

// TODO: zastąp prawdziwymi opiniami klienta
const TESTIMONIALS = [
  {
    quote:
      "Wszystko niezwykle sprawnie i bardzo dobra oferta dla klienta. Jak najbardziej polecam.",
    name: "Karolina B.",
  },
  {
    quote:
      "Najlepsze biuro ubezpieczeń. Profesjonalne podejście do sprawy oraz przemiła obsługa. Polecam wszystkim. Pozdrawiam.",
    name: "Piotr K.",
  },
  {
    quote:
      "Wszystko niezwykle sprawnie i bardzo dobra oferta dla klienta. Jak najbardziej polecam.",
    name: "Karol B.",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="opinie"
      data-testid="testimonials-section"
      className="py-20 md:py-28 bg-cream"
    >
      <div className="container-narrow">
        <Reveal>
          <div className="max-w-2xl">
            <div className="text-mustard-dark font-heading font-bold uppercase text-sm tracking-wider mb-3">
              Opinie klientów
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-forest leading-tight">
              Zobacz co mówią osoby, które już nam zaufały.
            </h2>
          </div>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-3 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={i} delay={i * 80}>
              <div
                data-testid={`testimonial-card-${i}`}
                className="bg-white rounded-2xl p-7 border border-bordersoft h-full flex flex-col"
              >
                <Quote size={28} className="text-mustard/60 mb-4" strokeWidth={1.8} />
                <div className="flex gap-1 mb-4" aria-label="5 z 5 gwiazdek">
                  {[...Array(5)].map((_, idx) => (
                    <Star
                      key={idx}
                      size={18}
                      className="text-mustard"
                      fill="#D49E35"
                      strokeWidth={1.5}
                    />
                  ))}
                </div>
                <p className="text-ink/90 text-base leading-relaxed italic flex-1">
                  „{t.quote}"
                </p>
                <div className="mt-5 pt-5 border-t border-bordersoft">
                  <div className="font-heading font-semibold text-forest text-base">
                    {t.name}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
